import { useEffect, useRef } from "react";

export function useAIRoomSocket(
  socket,
  roomName,
  sessionId,
  { setWaitingForPrompts, onRoomState, onOwnerState, onKicked },
) {
  // Use refs so cleanup always has the latest callbacks without re-registering
  const callbacksRef = useRef({
    setWaitingForPrompts,
    onRoomState,
    onOwnerState,
    onKicked,
  });
  callbacksRef.current = {
    setWaitingForPrompts,
    onRoomState,
    onOwnerState,
    onKicked,
  };

  useEffect(() => {
    socket.emit("join room", roomName);
    socket.emit("ai room reconnect", { roomName, sessionId });

    const onWaiting = () => callbacksRef.current.setWaitingForPrompts(true);
    const onStopWaiting = () =>
      callbacksRef.current.setWaitingForPrompts(false);
    const onState = (data) => callbacksRef.current.onRoomState(data);
    const onOwner = (data) => callbacksRef.current.onOwnerState(data);
    const onKick = (data) => {
      if (callbacksRef.current.onKicked) callbacksRef.current.onKicked(data);
    };

    socket.on("waitingForPrompts", onWaiting);
    socket.on("stopWaitingForPrompts", onStopWaiting);
    socket.on("ai room state", onState);
    socket.on("ai room owner state", onOwner);
    socket.on("ai room kicked", onKick);

    return () => {
      socket.off("waitingForPrompts", onWaiting);
      socket.off("stopWaitingForPrompts", onStopWaiting);
      socket.off("ai room state", onState);
      socket.off("ai room owner state", onOwner);
      socket.off("ai room kicked", onKick);
    };
  }, [socket, roomName, sessionId]);
}
